 const parseUrlHash = (hash) => {


     if (!hash) return {}

     var gid; //galleryId
     var pid; //pictureId
     var localAnchorId; //anchor link like: /#about

     var match = hash.match(/^#(\w+)/);
     localAnchorId = match && match[1]

     match = hash.match(/pid=([-\w]+)/)
     pid = match && match[1]

     match = hash.match(/gid=(\w+)/)
     gid = match && match[1]

     var urlObj = {
         localAnchorId: localAnchorId,
         pid: (pid ? pid.toLowerCase() : pid),
         gid: gid
     };
     return urlObj;

 }
 //hack to get local anchor links to work with react-router
 //https://stackoverflow.com/questions/40280369/use-anchors-with-react-router
 const hashLinkScroll = (id) => {
     setTimeout(() => {
         const element = document.getElementById(id);
         if (element) element.scrollIntoView();
     }, 0);
 }

 const getRandomInt = (min, max) => {
     return Math.floor(Math.random() * (max - min)) + min;
 }

 const sendPageView = () => {
     window.ga('send', 'pageview', {
         'page': document.location.href
     });
     console.log("pageview:" + document.location.href);
 }

 const Utils = {
     parseUrlHash: parseUrlHash,
     hashLinkScroll: hashLinkScroll,
     getRandomInt: getRandomInt,
     sendPageView: sendPageView
 }
 export default Utils